<template>
	<div>
		<sub-header bizCd="01"/>
		<div class="sub_visual sub03">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">특성화고(마이스터고) 온라인 취업교육</div>
                    <div class="comment">지역인재 공무원부터 공기업 특별채용까지,<br>
                        시작부터 합격까지 에듀윌이 함께하겠습니다.</div>
                    <div class="action pc_hidden">
                        <div><a href="//img.eduwill.net/resources/b2b/dev/[에듀윌] 특성화고등학교 취업교육 제안서.pdf"
                        target="_blank" class="btn-1">취업교육 제안서<i class="icon icon-arrow"></i></a></div>
                    </div>
                </div>
            </div>
        </div>
		
		<div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <div class="sub_tit">교육과정</div>
                    <div class="con">
                        <div class="txt line02">합격자들이 선택한 바로 그 강의!<br>
                            지금 가장 HOT한 특성화고 학생을 위한 취업 성공 강좌를 확인하세요.</div>
                        <div class="course_list">
                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-public.png"
                                                alt="공무원" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-public@3x.png"
                                                alt="공무원" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">공무원</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 지역인재 특별과정</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-suitcase.png"
                                                alt="NCS&인적성" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-suitcase@3x.png"
                                                alt="NCS&인적성" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">NCS&amp;인적성</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 공기업 NCS</li>
                                            <li>・ 대기업 인적성 (삼성GSAT 등)</li>
                                            <li>・ 금융권 과정</li>
                                            <li>・ 대기업 직무적성검사</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/02-icon-ncs.png"
                                                alt="실전 취업 특강" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-ncs@3x.png"
                                                alt="실전 취업 특강" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">실전 취업 특강</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ 이력서 작성 </li>
                                            <li>・ 자기소개서 작성</li>
                                            <li>・ 실전 모의 면접</li>
                                            <li>・ 커리어 포트폴리오 </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license.png"
                                                alt="자격증" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon-license@3x.png"
                                                alt="자격증" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">자격증</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list last_long">
                                            <li>・ 전산세무 1,2급</li>
                                            <li>・ ERP회계 1,2급</li>
                                            <li>・ 전산회계 1,2급</li>
                                            <li>・ ERP물류 1,2급</li>
                                            <li>・ 한국사능력검정</li>
                                            <li>・ ERP생산 1,2급</li>
                                            <li>・ 워드프로세서</li>
                                            <li>・ ERP인사 1,2급</li>
                                            <li>・ 매경 TEST</li>
                                            <li>・ 한경 TESAT</li>
                                            <li>・ 컴퓨터활용능력 1,2급</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="course_box h230">
                                <div class="p_wrap">
                                    <div class="co_tit">
                                        <div class="icon">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language.png"
                                                alt="어학" class="pc840hidden" />
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/icon_language@3x.png"
                                                alt="어학" class="mobile840hidden" />
                                        </div>
                                        <div class="txt">어학</div>
                                    </div>
                                    <div class="co_contents">
                                        <ul class="co_list wide">
                                            <li>・ TOEIC</li>
                                            <li>・ TOPIK I,II</li>
                                            <li>・ 무역영어</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="sub_tit">교육담당자 <br class="m_hidden">후기</div>
                    <div class="con">
                        <div class="txt txt_line2">리얼 맞춤형 강의! 에듀윌 특성화고 온라인 취업교육</div>
                        <div class="section-review">
                            <div class="item-slick item-slick-sub h298">
                                <div class="slick-inner">
                                    <div class="box">
                                        <div class="text-1">진짜 대한민국 최고의 교육사이트 1위 맞습니다.</div>

                                        <div class="text-2"><span>교육 진행시의 피드백이 빠르고 학생 중심의 교육 운영이</span><br>
                                            프로그램 만족도 향상에 도움이 되었습니다.</div>
                                        <div class="who">
                                            목포여자상업고등학교 취업 교육 담당자
                                        </div>
                                        <div class="img img-7"><img
                                                src="//img.eduwill.net/resources/b2b/dev/images/roll-img-07.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sec none-padding">
                    <div class="sub_tit">
                        <div class="mx200">지역인재 공무원</div>
                        <a href="//img.eduwill.net/resources/b2b/dev/2022년도 지역인재 9급 수습직원 선발시험 추천 매뉴얼.pdf"
                            target="_blank" class="btn_default pc840hidden">응시자격 상세보기</a>
                    </div>
                    <div class="con">
                        <div class="txt">매년 증가하는 채용인원, 지금 시작해야 합니다!</div>
                        <div class="img_wrap pc840hidden">
                            <div class="spec_local">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-local-01.png">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-local-02.png">
                                <img src="//img.eduwill.net/resources/b2b/dev/images/img-local-03.png">
                            </div>
                        </div>
                        <div class="responsive_slider mobile840hidden">
                            <div class="swiper-container img-role" id="">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-local-01@3x.png"></div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-local-02@3x.png"></div>
                                    <div class="swiper-slide"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/img-local-03@3x.png"></div>
                                </div>

                                <!-- Add Pagination -->
                                <div class="swiper-pagination"></div>

                                <!-- Add Arrows -->
                                <div class="pa-button swiper-button-next"></div>
                                <div class="pa-button swiper-button-prev"></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="sec">
                    <div class="sub_tit">
                        <p class="mx200">NCS 왕기초 과정</p>
                    </div>
                    <div class="con">
                        <div class="txt">NCS가 처음인 고등학생의 눈높이에 맞춘 커리큘럼으로, 흥미롭고 쉬운 학습이 가능합니다 .</div>
                        <div class="wide_step">
                            <div class="line">
                                <div class="step_tit">NCS궁금증 완벽 해결</div>
                                <div class="step_comm">공부해도 오르지 않은 이유는? 현실적인 NCS 학습계획 세우기</div>
                            </div>
                            <div class="line">
                                <div class="step_tit">영역별 이론 + 문제풀이</div>
                                <div class="step_comm">2주 만에 합격하는 학습법과 문제 풀이</div>
                            </div>
                            <div class="line">
                                <div class="step_tit">모듈형 NCS 완벽 분석</div>
                                <div class="step_comm">모듈형 NCS 도대체 무엇인가? 구체적 예시로 알아보기</div>
                            </div>
                            <div class="line">
                                <div class="step_tit"><span class="step_point">실력 UP! 무료제공</span><span>NCS 영역별 심화
                                        학습</span></div>
                                <div class="step_comm">이시한의 NCS 스킬 독점 공개! NCS정석 강좌</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sec">
                    <div class="clearfix">
                        <div class="sub_tit">특성화고 취업교육 Flow</div>
                    </div>
                    <div class="con_wide">
                        <div class="flow_common flow_m_hidden">
                            <div class="f_wrap">
                                <div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-03-01.png" alt="대학" />
                                </div>
                                <div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450"
                                    data-aos-offset="0">
                                    <div class="text">비용 지원/위탁</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">과정 지원/운영보고</div>
                                </div>
                                <div class="step03 step_edu aos-item" data-aos="fade-right" data-aos-delay="600"
                                    data-aos-offset="0">
                                    <div class="step_edu_con">
                                        <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                        <p>에듀윌</p>
                                    </div>
                                </div>
                                <div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750"
                                    data-aos-offset="0">
                                    <div class="text">학습상담/지원</div>
                                    <div class="arrow_right"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표" />
                                    </div>
                                    <div class="arrrow_left"><img
                                            src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png"
                                            alt="flow화살표" /></div>
                                    <div class="text">강좌 수강/학습 문의</div>
                                </div>
                                <div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900"
                                    data-aos-offset="0"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img-flow-03-03.png" alt="재학생" />
                                </div>
                            </div>
                        </div>

                        <!-- flow Mobile  -->
                        <div class="flow_common flow_pc_hidden">
                            <div class="f_wrap">
                                <div class="wide">
                                    <div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450"
                                        data-aos-offset="0">
                                        <div class="step_edu_con">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png" />
                                            <p>에듀윌</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="stepper">
                                    <div class="img_left aos-item" data-aos="fade-right" data-aos-delay="300"
                                        data-aos-offset="0">
                                        <div class="flow_mo_left">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_3_left.png" />
                                        </div>
                                    </div>
                                    <div class="img_right aos-item" data-aos="fade-right" data-aos-delay="600"
                                        data-aos-offset="0">
                                        <div class="flow_mo_right">
                                            <img src="//img.eduwill.net/resources/b2b/dev/images/flow01_3_right.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="sub_partner">
                <div class="container">
                    <div class="title_line">
                        <div class="pa_tit">Partner</div>
                        <div class="text">에듀윌과 함께하는 특성화고(마이스터고) 온라인 취업교육 파트너입니다.</div>
                    </div>
                    <ul class="pa_slider_scroll">
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-127.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-128.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-129.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-130.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-131.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-132.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-133.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-134.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-135.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-136.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-137.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-138.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-139.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-140.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-141.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-142.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-143.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-144.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-145.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_3/ci_33_220711.png" /></li>
                        <li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/01_3/ci_34_220711.png" /></li>
                    </ul>
                </div>
            </div>
        </div>
	<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌 특성화고<br>취업교육 서비스</div>
                <div class="button"><a href="//img.eduwill.net/resources/b2b/dev/[에듀윌] 특성화고등학교 취업교육 제안서.pdf"
                        target="_blank">제안서 다운로드</a></div>
                <div class="ico-hand"></div>
            </div>
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "SpecialHighSchoolEduSell",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
}
</script>

<style scoped>

</style>
